import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { isDate } from 'moment';
import { DateTimeService } from 'src/app/core/services/date-time.service';

@Component({
  selector: 'date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DateTimePickerComponent implements OnInit {
  @Input() date: any;
  @Input() isOnlyYear: boolean = false;
  monthYear: any;
  max: string
  days: Array<number> = [];
  min: string;
  months: Array<any> = [];
  years: Array<any> = [];
  monthIndex;
  dayIndex;
  yearIndex;
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  constructor(private dateTimeService: DateTimeService, private ch: ChangeDetectorRef) { }

  ngOnInit() {
    if (this.date && !isDate(this.date))
      this.date = new Date(this.date);
    else if (!this.date)
      this.date = new Date();
    this.setMonth(this.date.getFullYear());
    this.monthYear = new Date(this.date).toISOString();
    this.dayIndex = new Date(this.date).getDate();
    this.monthIndex = new Date(this.date).getMonth() + 1;
    this.yearIndex = new Date(this.date).getFullYear();
    this.setYear();
    let dayCount = this.dateTimeService.getDays(new Date(this.date).toISOString());
    this.days = this.getArray(dayCount);
    //this.dateSet();
    //data atama
  }
  setYear() {
    let year = this.yearIndex;
    this.yearIndex = null;
    for (let index = 1970; index < year + 60; index++) {
      this.years.push(index);
    }
    this.yearIndex = this.years.indexOf(year) + 1;
  }

  setMonth(year: number) {
    for (let index = 0; index < 12; index++) {
      this.months.push(this.dateTimeService.formatDate(new Date(year, index, 1, 0, 0, 0), "MMM"))
    }
  }

  onDayChange(ev) {
    this.dayIndex = ev;
    this.dateSet();
  }

  onMonthChange(ev) {
    this.monthIndex = ev;
    this.dayCountSetWithoutDay();
    this.dateSet();
  }

  onYearChange(ev) {
    this.yearIndex = ev;
    this.dayCountSetWithoutDay();
    this.dateSet();

  }

  dayCountSetWithoutDay() {
    let date = new Date(this.years[this.yearIndex] - 1, this.monthIndex - 1, 1, 12, 0, 0);
    let dayCount = this.dateTimeService.getDays(new Date(date).toISOString());
    this.days = this.getArray(dayCount);
    if (this.dayIndex > this.days.length) {
      this.dayIndex = this.days[this.days.length - 1]
    }
  }

  dateSet() {
    this.date = new Date(this.years[this.yearIndex] - 1, this.monthIndex - 1, this.dayIndex, 12, 0, 0);
    if (this.isOnlyYear) {
      this.date = new Date(this.years[this.yearIndex] - 1, 1, 1, 12, 0, 0);
    }
    this.onChange.emit(this.date);
  }

  getArray(i: number) {
    let array = [];
    for (let index = 0; index < i; index++) {
      array.push(index + 1);
    }
    return array;
  }

}
